class DownTo0 {
    run (value) {
        return (Math.abs(value) < 1e-9) ? 0 : value
    }
}

export default DownTo0;